import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import { LeadProvider } from './Utils/LeadContext';
import IndexPage from './Modules/Index/Index';
import Guide from './Modules/Guides/Guide';
import GQik from './Modules/Guides/GQik';
import Intro from './Modules/Guides/Intro';
import Offer from './Modules/Guides/Offer';
import FeedBack from './Modules/Guides/FeedBack';
import NotFoundPage from './Components/Common/NotFoundPage';
import './index.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import BookDemo from './Modules/Demo/Demo';
import { BrandProvider } from './Utils/BrandContext';
import BrandSync from './Utils/BrandSync';
import GPower from './Modules/Guides/GPower';
import { useSearchParams as useOfferParams, useNavigate as useOfferNavigate } from 'react-router-dom';

const createRedirect = (targetPage, defaultScroll = '') => () => {
  const [searchParams] = useOfferParams();
  React.useEffect(() => {
    const i = searchParams.get('i') || '';
    const o = searchParams.get('o') || '';
    const m = searchParams.get('m') || '';
    const scroll = searchParams.get('scroll') || defaultScroll;
    const mQuery = m ? `&m=${m}` : '';
    const scrollQuery = scroll ? `&scroll=${scroll}` : '';
    const baseUrl = window.location.hostname === 'localhost'
      ? `http://localhost:${window.location.port}/QikERP`
      : `${window.location.origin}/QikERP`;
    window.location.href = `${baseUrl}/${targetPage}?i=${i}&o=${o}${mQuery}${scrollQuery}`;
  }, []);
  return null;
};

const GQikRedirect = createRedirect('GPower');
const OfferRedirect = createRedirect('GPower', 'pricing');

// 🔧 BRAND CONTROL: Change here to switch between 'bz' and 'qikerp'

function App() {
  return (
    <BrandProvider defaultBrand="qikerp">
      <LeadProvider>
        <Router basename='QikERP'>
          <BrandSync />
          <Toaster position="bottom-right" expand={false} />
          <Routes>
            <Route path="/" element={<IndexPage />} />
            <Route path="/Guide" element={<Guide />} />
            <Route path="/GQIK" element={<GQik />} />
            <Route path="/GPower" element={<GPower />} />
            <Route path="/Intro" element={<Intro />} />
            <Route path="/Offer" element={<OfferRedirect />} />
            <Route path="/Demo" element={<BookDemo />} />
            <Route path="/FeedBack" element={<FeedBack />} />
            <Route path="/fdbk" element={<FeedBack />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </Router>
      </LeadProvider>
    </BrandProvider>
  );
}
export default App;